const getSignUpLink = (locale) => {
    const link = 'https://app.schedulino.com/signup';
    return locale === 'en' ? link : `${link}?lang=${locale}`;
};

module.exports = getSignUpLink;
